import { Button, useMediaQuery, Typography } from '@mui/material';
import { useFilters } from './hooks/useFilters';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { theme } from '@store';

export const Filters = () => {
  const { handleToggleFiltersCard, isFiltersCardOpen, appliedFiltersCount } =
    useFilters();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Button
      sx={{
        display: 'flex',
        gap: 0.5,
        fontWeight: 'medium',
        fontSize: '15px',
        ...(isFiltersCardOpen && {
          bgcolor: theme.palette.selectedTableRowBg.main,
        }),
      }}
      variant='text'
      onClick={handleToggleFiltersCard}
    >
      <FilterAltIcon />
      <Typography sx={{ fontSize: '15px', fontWeight: 'medium' }}>
        {!isFiltersCardOpen && !isSmallScreen && 'FILTERS'}
      </Typography>
      <Typography sx={{ fontSize: '15px', fontWeight: 'medium' }}>
        {appliedFiltersCount > 0 ? `(${appliedFiltersCount})` : ''}
      </Typography>
    </Button>
  );
};
